var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"about"},domProps:{"innerHTML":_vm._s(_vm.getOrganization.data.block1)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }